export default class Helpers {
  static deepCopy(data: any) {
    return JSON.parse(JSON.stringify(data));
  }

  static cleanNull(data: any) {
    if (typeof (data) === "object" && data !== null && data !== undefined) {
      for (const key of Object.keys(data)) {
        if (data[key] === null) {
          delete data[key];
        } else {
          Helpers.cleanNull(data[key])
        }
      }
    } else if (Array.isArray(data)) {
      for (const item of data) {
        Helpers.cleanNull(item);
      }
    }
  }
}
